import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.string.starts-with.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import TextLink from 'components/TextLink';
import Button from 'components/Button';
import Flex from 'components/Flex';
import Box from 'components/Box';
import Stack from 'components/Stack';
import CheckboxOption from 'components/CheckboxOption';
import Hint from 'components/Hint';
import { Description, DescriptionList } from 'components/DescriptionList';
import OverflowTooltip from 'components/OverflowTooltip';
import EditLinkModal from 'screens/EditLinkModal';
import getEmbeddedVideo from 'utils/getEmbeddedVideo';
import LastUpdatedDescription from '../Descriptions/LastUpdatedDescription';
import DividerPanel from './DividerPanel';
import { ASSET_WRITE, hasPrivilege } from 'utils/privileges';
import AssetLibraryDescription from '../Descriptions/AssetLibraryDescription';
export default function LinkDetailsPanel(_ref) {
  var _webUrl$value;
  var id = _ref.id,
    fields = _ref.fields,
    lastUpdated = _ref.lastUpdated,
    content = _ref.content;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasAssetPermissions = hasPrivilege(ASSET_WRITE);
  var customType = fields.customType,
    webUrl = fields.webUrl,
    openInIframe = fields.openInIframe,
    parentId = fields.parentId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showEditLinkModal = _useState2[0],
    setShowEditLinkModal = _useState2[1];
  var updateWebUrl = function updateWebUrl(url) {
    // Check customtype of the new URL and update it, if it changed
    var newUrlCustomType = getEmbeddedVideo(url) ? 'video' : 'web';
    if (customType.value !== newUrlCustomType) {
      customType.set(newUrlCustomType);
    }
    webUrl.set(url);
    setShowEditLinkModal(false);
  };
  var urlId = useUniqueId(String(id));
  var urlIsInsecure = !((_webUrl$value = webUrl.value) !== null && _webUrl$value !== void 0 && _webUrl$value.startsWith('https://'));
  return /*#__PURE__*/React.createElement(DividerPanel, {
    header: t('content_type_link_details')
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(DescriptionList, {
    titleWidth: 1 / 4
  }, /*#__PURE__*/React.createElement(Description, {
    title: t('form_url_colon')
  }, /*#__PURE__*/React.createElement(Flex, {
    align: "top"
  }, /*#__PURE__*/React.createElement(OverflowTooltip, {
    content: webUrl.value
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    mr: "s",
    overflow: "ellipsis"
  }, /*#__PURE__*/React.createElement(TextLink, {
    id: urlId,
    target: "_blank",
    href: webUrl.value,
    title: webUrl.value
  }, webUrl.value))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "transparent",
    icon: "edit",
    onClick: function onClick() {
      return setShowEditLinkModal(true);
    }
  }, t('actions_edit_url'))))), /*#__PURE__*/React.createElement(LastUpdatedDescription, {
    lastUpdated: lastUpdated
  }), hasAssetPermissions && /*#__PURE__*/React.createElement(AssetLibraryDescription, {
    content: content,
    folderId: parentId.value,
    updateFolderLocation: function updateFolderLocation(value) {
      return parentId.set(value);
    }
  })), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckboxOption, {
    fontSize: "s",
    label: t('actions_open_in_new_window'),
    id: "open-in-new-window",
    checked: !openInIframe.value,
    onChange: function onChange(e) {
      return openInIframe.set(!e.target.checked);
    },
    disabled: urlIsInsecure,
    "aria-describedby": urlIsInsecure ? 'url-insecure-hint' : undefined
  }), urlIsInsecure && /*#__PURE__*/React.createElement(Hint, {
    id: "url-insecure-hint",
    my: "xs"
  }, t('hints_disable_option_for_secure_url')))), showEditLinkModal && /*#__PURE__*/React.createElement(EditLinkModal, {
    onClose: function onClose() {
      return setShowEditLinkModal(false);
    },
    onSubmit: updateWebUrl,
    defaultValue: webUrl.value
  }));
}